module.exports = __webpack_public_path__ + "static/media/inviteModalHelpGuide.cc751565.png";